import { Outlet, useParams } from 'react-router-dom';

import { BreadCrumb } from '@/components/breadcrumb/breadcrumb';
import { AppSidebar } from '@/components/sidebar/appSidebar';
import { SidebarInset } from '@/components/ui/sidebar';
import type { DashboardItem } from '@/models/dashboardItem';

interface DashboardProps {
  items?: DashboardItem[];
  menu: boolean;
}

const Dashboard = (props: DashboardProps) => {
  // useParams (not useSandboxContext): Dashboard also renders on the game-level
  // sandboxes page, which is outside SandboxProvider. sandboxCode is undefined there.
  const { gameCode, sandboxCode } = useParams();
  return (
    <>
      <BreadCrumb />
      <div className="flex w-full flex-1 min-h-0">
        <AppSidebar items={props.items?.filter((item) => !item.disabled)} />
        <SidebarInset className="isolate">
          {/* Remount page content on game/sandbox switch so pages holding local
              state (e.g. the multi-step import forms) reset to the new scope
              instead of carrying stale data across the boundary. */}
          <div
            key={`${gameCode}/${sandboxCode}`}
            className="layout overflow-x-auto @container/panel"
          >
            <Outlet />
          </div>
        </SidebarInset>
      </div>
    </>
  );
};

export default Dashboard;
